import React from 'react';
import clsx from 'clsx';

import './ThreeDotsLoader.scss';

const ThreeDotsLoader: React.FC<{ big?: boolean }> = ({ big = false }) => (
  <div className={clsx('three-dots-loader-wrapper', { big })}>
    <div className="c-three-dots-loader" />
  </div>
);

export default ThreeDotsLoader;
